export enum UploadProviders {
  NFT_STORAGE = 'nft.storage',
  INFURA = 'infura',
}

export const UPLOAD_PROVIDER = UploadProviders.INFURA;

// NFT Storage
export const NFT_STORAGE_API_TOKEN = process.env.NFTSTORAGE_API_TOKEN;

// Infura
export const INFURA_URL = 'https://ipfs.infura.io:5001';
export const INFURA_AUTHENTICATED = false;
